"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = suggestedActions;

var _clearSuggestedActions = require("../actions/clearSuggestedActions");

var _setSuggestedActions = require("../actions/setSuggestedActions");

var DEFAULT_STATE = [];

function suggestedActions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload,
      type = _ref.type;

  switch (type) {
    case _setSuggestedActions.SET_SUGGESTED_ACTIONS:
      if ((payload.suggestedActions || []).length) {
        state = [].slice.call(payload.suggestedActions);
      } else {
        state = DEFAULT_STATE;
      }

      break;

    case _clearSuggestedActions.CLEAR_SUGGESTED_ACTIONS:
      state = DEFAULT_STATE;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX1NUQVRFIiwic3VnZ2VzdGVkQWN0aW9ucyIsInN0YXRlIiwicGF5bG9hZCIsInR5cGUiLCJTRVRfU1VHR0VTVEVEX0FDVElPTlMiLCJsZW5ndGgiLCJzbGljZSIsImNhbGwiLCJDTEVBUl9TVUdHRVNURURfQUNUSU9OUyJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9zdWdnZXN0ZWRBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TIH0gZnJvbSAnLi4vYWN0aW9ucy9jbGVhclN1Z2dlc3RlZEFjdGlvbnMnO1xuaW1wb3J0IHsgU0VUX1NVR0dFU1RFRF9BQ1RJT05TIH0gZnJvbSAnLi4vYWN0aW9ucy9zZXRTdWdnZXN0ZWRBY3Rpb25zJztcblxuY29uc3QgREVGQVVMVF9TVEFURSA9IFtdO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzdWdnZXN0ZWRBY3Rpb25zKHN0YXRlID0gREVGQVVMVF9TVEFURSwgeyBwYXlsb2FkID0ge30sIHR5cGUgfSkge1xuICBzd2l0Y2ggKHR5cGUpIHtcbiAgICBjYXNlIFNFVF9TVUdHRVNURURfQUNUSU9OUzpcbiAgICAgIGlmICgocGF5bG9hZC5zdWdnZXN0ZWRBY3Rpb25zIHx8IFtdKS5sZW5ndGgpIHtcbiAgICAgICAgc3RhdGUgPSBbXS5zbGljZS5jYWxsKHBheWxvYWQuc3VnZ2VzdGVkQWN0aW9ucyk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBzdGF0ZSA9IERFRkFVTFRfU1RBVEU7XG4gICAgICB9XG4gICAgICBicmVhaztcbiAgICBjYXNlIENMRUFSX1NVR0dFU1RFRF9BQ1RJT05TOlxuICAgICAgc3RhdGUgPSBERUZBVUxUX1NUQVRFO1xuICAgICAgYnJlYWs7XG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUEsSUFBTUEsYUFBYSxHQUFHLEVBQXRCOztBQUVlLFNBQVNDLGdCQUFULEdBQXlFO0VBQUEsSUFBL0NDLEtBQStDLHVFQUF2Q0YsYUFBdUM7O0VBQUE7RUFBQSx3QkFBdEJHLE9BQXNCO0VBQUEsSUFBdEJBLE9BQXNCLDZCQUFaLEVBQVk7RUFBQSxJQUFSQyxJQUFRLFFBQVJBLElBQVE7O0VBQ3RGLFFBQVFBLElBQVI7SUFDRSxLQUFLQywwQ0FBTDtNQUNFLElBQUksQ0FBQ0YsT0FBTyxDQUFDRixnQkFBUixJQUE0QixFQUE3QixFQUFpQ0ssTUFBckMsRUFBNkM7UUFDM0NKLEtBQUssR0FBRyxHQUFHSyxLQUFILENBQVNDLElBQVQsQ0FBY0wsT0FBTyxDQUFDRixnQkFBdEIsQ0FBUjtNQUNELENBRkQsTUFFTztRQUNMQyxLQUFLLEdBQUdGLGFBQVI7TUFDRDs7TUFDRDs7SUFDRixLQUFLUyw4Q0FBTDtNQUNFUCxLQUFLLEdBQUdGLGFBQVI7TUFDQTs7SUFDRjtNQUNFO0VBWko7O0VBZUEsT0FBT0UsS0FBUDtBQUNEIn0=